import { put, takeLatest, all, call } from "redux-saga/effects";
import { toast } from "react-toastify";

import {
  SubadminListSuccess,
  SubadminListFailure,
  createPermissionSuccess,
  createPermissionFailure,
  updatePermissionSuccess,
  updatePermissionFailure,
  updatePermission,
  updateSubadminFailure,
  updateSubadminSuccess,
  viewSubadminFailure,
  viewSubadminSuccess
} from "../../actions";
import {
  GET_SUBADMIN,
  GET_COMPONENTS,
  SHOW_COMPONENT,
  UPDATE_COMPONENT,
  CREATE_COMPONENT,
  UPLOAD_QUIZ,
  CREATE_PERMISSION,
  UPDATE_PERMISSION,
  UPDATE_PERMISSION_SUCCESS,
  UPDATE_PERMISSION_FAILURE,
  UPDATE_SUBADMIN,
  VIEW_SUBADMIN
} from "../../Actions/types";
import api from "../../../helper/api";
import { deleteCookies, getCookies } from "../../../helper/constant";
import axios from "axios";



function* fetchSubAdmin(action) {
  try {
    
    const response = yield api.post(
      "admin/listSubAdmin",
      action?.payload?.payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    
    if (response?.status === 200 && response?.data?.status === "success") {
      yield put(SubadminListSuccess({ getData: response?.data }));
      yield call(action?.payload?.callback, response?.data);
    } else {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(SubadminListSuccess({ getError: e }));
  }
}



function* createPermission(action) {
  try {
    const response = yield api.post(
      "admin/register",
      action?.payload?.form,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    
    if (response?.status === 200 && response?.data?.status === "success") {
      toast.success(response?.data?.message);
      yield call(action?.payload?.callback, response?.data?.data);
      yield put(createPermissionSuccess({ createData: response?.data?.data }));
    } else {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    
    toast.error(e?.response?.data?.message);
    yield put(createPermissionFailure({ createError: e }));
  }
}

function* updateStatusRoleManagement(action) {
  try {
    const response = yield api.post(
      "admin/school/update-status",
      action?.payload?.form,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    if (response?.status === 200 && response?.data?.status === 200) {
      toast.success(response?.data?.message);
      yield call(action?.payload?.callback, response?.data?.data);
      yield put(updatePermissionSuccess({ updatePermission: response?.data?.data }));
    } else {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.message)
    yield put(updatePermissionFailure({ updateStatusError: e }));
  }
}


function* UpdateSubadmin(action) {
  
  try {
    const response = yield api.put(
      `/admin/editProfile/${action?.payload?.form?.id}`,
       action?.payload?.form,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    
    if (response?.status === 200 && response?.data?.status === "success") {
      toast.success(response?.data?.message);

      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        updateSubadminSuccess({ editAdminData: response?.data?.data })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(updateSubadminFailure({ editSubadminError: e }));
  }
}

function* viewSubAdmin(action) {
  
  try {
    const response = yield api.get(
      `/admin/getProfile/${action?.payload?.form.id}`
    );

    
    if (response?.status === 200 && response?.data?.status === "success") {
      // toast.success(response?.data?.message);

      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        viewSubadminSuccess({
          viewdata: response?.data?.data,
        })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      // toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(viewSubadminFailure({ viewsublessionerror: e }));
  }
}


function* updateStatusWatcher() {
  yield takeLatest(UPDATE_PERMISSION, updateStatusRoleManagement);
}
function* createPermissionWatcher() {
  yield takeLatest(CREATE_PERMISSION, createPermission);
}
function* SubAdminWatcher() {
  yield takeLatest(GET_SUBADMIN, fetchSubAdmin);
}
function* UpdateSubadminWatcher() {
  yield takeLatest(UPDATE_SUBADMIN, UpdateSubadmin);
}
function* Viewsubadminwatcher() {
  yield takeLatest(VIEW_SUBADMIN, viewSubAdmin);
}
export default function* PermissionSaga() {
  yield all([
    createPermissionWatcher(),
    SubAdminWatcher(),
    updateStatusWatcher(),
    UpdateSubadminWatcher(),
    Viewsubadminwatcher()
    // updateComponentWatcher(),
  ]);
}
